import React, { useState, useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';
import { useAnimation, motion } from 'framer-motion';

const TechnologiesWeUse = () => {
    const [imageLoad, setImageLoad] = useState(false);
    const [load, setLoad] = useState(true);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const mainControls = useAnimation();
    const transition = { duration: 0.8 };

    // Example technologies array (you need to populate this with actual data)
    const technologies = [
        {
            image: require("../assets/images/Technologies/html.png"),
            name: "HTML5",
        },
        {
            image: require("../assets/images/Technologies/css.png"),
            name: "CSS 3",
        },
        {
            image: require("../assets/images/Technologies/javascript.png"),
            name: "Javascript",
        },
        {
            image: require("../assets/images/Technologies/react-1-logo-png-transparent.png"),
            name: "React",
        },
        {
            image: require("../assets/images/Technologies/Angular_full_color_logo.svg.png"),
            name: "Angular",
        },
        {
            image: require("../assets/images/Technologies/reactNative.png"),
            name: "React Native",
        },
        {
            image: require("../assets/images/Technologies/flutter.png"),
            name: "Flutter",
        },
        {
            image: require("../assets/images/Technologies/androidStudio.png"),
            name: "Android Studio",
        },
        {
            image: require("../assets/images/Technologies/python.png"),
            name: "Python",
        },
        {
            image: require("../assets/images/Technologies/nodejs.png"),
            name: "Nodejs",
        },
        // {
        //   image: require("../images/Technologies/bootstrap.png"),
        //   name : "Bootstrap"
        // },
        // {
        //   image: require("../images/Technologies/jquery.png"),
        //   name : "Jquery"
        // },
        // {
        //   image: require("../images/Technologies/typescript.png"),
        //   name: "Typescript"
        // },
        // {
        //   image: require("../images/Technologies/cpanel.png"),
        //   name : "Cpanel"
        // },
        // {
        //   image: require("../images/Technologies/amazon.png"),
        //   name : "AWS"
        // },
        // {
        //   image: require("../images/Technologies/mongodb.png"),
        //   name : "MongoDB"
        // },
        // {
        //   image: require("../images/Technologies/sql.png"),
        //   name : "SQL"
        // },
        // {
        //   image: require("../images/Technologies/hostinger.png"),
        //   name : "Hostinger"
        // },
    ];


    const firsttechnologies = technologies.slice(0, 5);
    const secondtechnologies = technologies.slice(5, 10);

    useEffect(() => {
        if (isInView) {
            mainControls.start("visible");
        }
    }, [isInView, mainControls]);

    useEffect(() => {
        setLoad(false);
    }, []);

    const fadeInAnimationVarinats = {
        initial: {
            opacity: 0,
            y: 150,
        },
        animate: (index) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: 0.25 * index,
                duration: 0.8,
            },
        }),
    };

    return (
        <div ref={ref}>
            <div className="flex flex-col justify-center items-center my-6">
                <motion.div
                    variants={fadeInAnimationVarinats}
                    initial="initial"
                    whileInView="animate"
                    viewport={{
                        once: true,
                    }}
                    className="flex justify-center items-center mt-6"
                >
                    <div>
                        <h2 className="text-logo md:text-3xl text-2xl font-semibold">
                            Technologies <span className="text-black">we Use</span>
                        </h2>
                        <div className="border-t-4 border-orange-500 mt-2 w-10 mx-auto rounded-full"></div>
                    </div>

                </motion.div>
                <div className="flex flex-col justify-center items-center mt-16 mb-10 md:px-0 px-6">
                    <div className="grid md:grid-cols-5 grid-cols-1 justify-between items-center md:gap-16 gap-12 lg:gap-24 text-center w-auto mx-auto">
                        {firsttechnologies.map((tech, index) => (
                            <motion.div
                                key={index}
                                variants={fadeInAnimationVarinats}
                                initial="initial"
                                whileInView="animate"
                                viewport={{
                                    once: true,
                                }}
                                custom={index}
                                className="flex flex-col justify-center items-center"
                            >
                                <img
                                    loading="lazy"
                                    onLoad={() => {
                                        setImageLoad(true);
                                    }}
                                    className={!imageLoad ? `blur-md` : ``}
                                    alt=""
                                    src={tech.image}
                                    width={80}
                                    height={80}
                                    style={{ borderRadius: 15 }}
                                />
                                <h1 className="md:text-lg text-base mt-1">
                                    {tech.name}
                                </h1>
                            </motion.div>
                        ))}
                        {secondtechnologies.map((tech, index) => (
                            <motion.div
                                key={index}
                                variants={fadeInAnimationVarinats}
                                initial="initial"
                                whileInView="animate"
                                viewport={{
                                    once: true,
                                }}
                                custom={index}
                                className="flex flex-col justify-center items-center"
                            >
                                <img
                                    loading="lazy"
                                    onLoad={() => {
                                        setImageLoad(true);
                                    }}
                                    className={!imageLoad ? `blur-md` : ``}
                                    alt=""
                                    src={tech.image}
                                    width={80}
                                    height={80}
                                    style={{ borderRadius: 15 }}
                                />
                                <h2 className="md:text-lg text-base mt-1">
                                    {tech.name}
                                </h2>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TechnologiesWeUse;
